import type { AmbassadorsPageState } from './types';

export const INITIAL_STATE: AmbassadorsPageState = {
	contractModal: {
		open: false,
		source: null,
	},
};
